import React from 'react';
import classnames from 'classnames';
import draftToHtml from 'draftjs-to-html';

import css from './DraftContent.module.css';

const DraftContent = props => {
  const { draftContent, className } = props;

  if (!draftContent) {
    return null;
  }

  const draftContentToString = JSON.stringify(draftContent);
  const draftContentToObject = JSON.parse(draftContentToString);

  let parsedContent;

  try {
    parsedContent = JSON.parse(draftContent);
  } catch (e) {
    parsedContent = null;
  }

  const validContent =
    parsedContent &&
    Array.isArray(parsedContent.blocks) &&
    typeof parsedContent.entityMap === 'object';

  if (validContent) {
    let html;
    try {
      const formattedDraftContent = draftContent.replace(
        /(\"fontfamily-[^\}]*)/gi,
        '"fontfamily-Montserrat"'
      );
      html = draftToHtml(JSON.parse(formattedDraftContent));
    } catch (e) {
      html = draftToHtml(JSON.parse(draftContent));
    }

    return (
      <div className={classnames(css.root, className)}>
        <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: html.replace(/<a href=/gi, '<a rel="nofollow" href='),
          }}
        />
      </div>
    );
  } else {
    return <p className={classnames(css.root, className)}>{draftContent}</p>;
  }
};

export default DraftContent;
